import DashboardService from '../../services/DashboardService';
import swal from 'sweetalert';

export const GET_DASHBOARD_SUMMARY_REQUEST = 'GET_DASHBOARD_SUMMARY_REQUEST';
export const GET_DASHBOARD_SUMMARY_SUCCESS = 'GET_DASHBOARD_SUMMARY_SUCCESS';
export const GET_DASHBOARD_SUMMARY_FAILED = 'GET_DASHBOARD_SUMMARY_FAILED';

export const GET_DASHBOARD_CHART_REQUEST = 'GET_DASHBOARD_CHART_REQUEST';
export const GET_DASHBOARD_CHART_SUCCESS = 'GET_DASHBOARD_CHART_SUCCESS';
export const GET_DASHBOARD_CHART_FAILED = 'GET_DASHBOARD_CHART_FAILED';

export const CLEAR_DASHBOARD_ERRORS = 'CLEAR_DASHBOARD_ERRORS';

export const getDashboardSummaryAction = (companyId = null, branchId = null) => async (dispatch) => {
	try {
		dispatch({ type: GET_DASHBOARD_SUMMARY_REQUEST });
		const result = await DashboardService.getSummaryStats(companyId, branchId);
		if (result.success) {
			dispatch({
				type: GET_DASHBOARD_SUMMARY_SUCCESS,
				payload: result.data
			});
		} else {
			dispatch({
				type: GET_DASHBOARD_SUMMARY_FAILED,
				payload: result.message
			});
			swal('Error', result.message, 'error');
		}
	} catch (error) {
		dispatch({
			type: GET_DASHBOARD_SUMMARY_FAILED,
			payload: error.message || 'Failed to fetch dashboard summary'
		});
		swal('Error', 'Failed to fetch dashboard summary', 'error');
	}
};

export const getDashboardChartAction = (period = 'month', companyId = null, branchId = null) => async (dispatch) => {
	try {
		dispatch({ type: GET_DASHBOARD_CHART_REQUEST });
		const result = await DashboardService.getChartData(period, companyId, branchId);
		if (result.success) {
			dispatch({
				type: GET_DASHBOARD_CHART_SUCCESS,
				payload: {
					period,
					data: result.data
				}
			});
		} else {
			dispatch({
				type: GET_DASHBOARD_CHART_FAILED,
				payload: result.message
			});
		}
	} catch (error) {
		dispatch({
			type: GET_DASHBOARD_CHART_FAILED,
			payload: error.message || 'Failed to fetch chart data'
		});
	}
};

export const clearDashboardErrors = () => ({
	type: CLEAR_DASHBOARD_ERRORS
});
